<template>
  <div>
    <div>
      <div class="d-flex justify-space-between">
        <h2 class="font-24 font-lg-28 font-weight-bold primary--text">
          Your details
        </h2>
        <BaseButton
          :text="$vuetify.breakpoint.lgAndUp ? 'Save &amp; exit' : 'Save'"
          flat
          depressed
          ripple
          class="font-weight-bold px-1 py-3"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="saveAndExit"
        />
      </div>
    </div>

    <!-- the form -->
    <ValidationObserver ref="observerFormDetails">
      <form @submit.prevent="onSubmit">
        <h3 class="mt-8 mb-3 font-20 primary--text">Applicant 1</h3>
        <BaseLabel :text="LABEL_CONSTANTS.TITLE_LABEL" class="mb-2" />
        <BaseSelect
          dense
          :vid="questionApplicant1Title.InterfaceKey"
          v-model="questionApplicant1Title.Value"
          :items="applicantTitleOptions('Applicant1Title')"
          :isEnableSortOrderListItems="false"
          :data-uiid="questionApplicant1Title.InterfaceKey"
          :hide-details="false"
          :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseLabel :text="LABEL_CONSTANTS.FIRST_NAME_LABEL" class="mt-3 mb-2" />
        <BaseInput
          :vid="questionApplicant1Forename.InterfaceKey"
          v-model="questionApplicant1Forename.Value"
          :data-uiid="questionApplicant1Forename.InterfaceKey"
          :hide-details="false"
          :rules="applicantFirstNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseLabel :text="LABEL_CONSTANTS.LAST_NAME_LABEL" class="mt-3 mb-2" />
        <BaseInput
          :vid="questionApplicant1Surname.InterfaceKey"
          v-model="questionApplicant1Surname.Value"
          :data-uiid="questionApplicant1Surname.InterfaceKey"
          :hide-details="false"
          :rules="applicantLastNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
          class="mt-3 mb-2"
        />
        <BaseInputDate
          :vid="questionApplicant1DoB.InterfaceKey"
          :data-uiid="questionApplicant1DoB.InterfaceKey"
          :value="questionApplicant1DoB.Value"
          v-model="questionApplicant1DoB.Value"
          :rules="applicantDateOfBirthRules"
          :hideDetails="false"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseLabel
          :text="LABEL_CONSTANTS.GROSS_MONTHLY_INCOME"
          :helpText="LABEL_CONSTANTS.GROSS_MONTHLY_INCOME_HELP_TEXT"
          class="mt-3 mb-2"
        />
        <BaseInput
          ref="questionApplicant1GrossMonthlyIncome"
          :vid="questionApplicant1GrossMonthlyIncome.InterfaceKey"
          v-model="questionApplicant1GrossMonthlyIncome.Value"
          :value="questionApplicant1GrossMonthlyIncome.Value"
          prefix="£"
          moneyFormat
          dataUiid="questionApplicant1GrossMonthlyIncome"
          :hideDetails="false"
          :rules="applicant1GrossMonthlyRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '160px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
        />

        <BaseToggle
          v-model="questionSecondApplicantIncluded.Value"
          label="Add second applicant?"
          pslStyle="button"
          class="mt-1 second-applicant-included-field"
        />

        <!-- second applicant form -->
        <div v-if="questionSecondApplicantIncluded.Value" class="mt-7">
          <h3 class="mb-3 font-20 primary--text">Applicant 2</h3>
          <BaseLabel :text="LABEL_CONSTANTS.TITLE_LABEL" class="mb-2" />
          <BaseSelect
            v-model="questionApplicant2Title.Value"
            :vid="questionApplicant2Title.InterfaceKey"
            :items="applicantTitleOptions('Applicant2Title')"
            :isEnableSortOrderListItems="false"
            :data-uiid="questionApplicant2Title.InterfaceKey"
            :hide-details="false"
            :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
            :rules="{
              required: {
                required: true,
                fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.FIRST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            v-model="questionApplicant2Forename.Value"
            :vid="questionApplicant2Forename.InterfaceKey"
            :data-uiid="questionApplicant2Forename.InterfaceKey"
            :hide-details="false"
            :rules="applicantFirstNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.LAST_NAME_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInput
            v-model="questionApplicant2Surname.Value"
            :vid="questionApplicant2Surname.InterfaceKey"
            :data-uiid="questionApplicant2Surname.InterfaceKey"
            :hide-details="false"
            :rules="applicantLastNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
            class="mt-3 mb-2"
          />
          <BaseInputDate
            :vid="questionApplicant2DoB.InterfaceKey"
            :data-uiid="questionApplicant2DoB.InterfaceKey"
            :value="questionApplicant2DoB.Value"
            :hideDetails="false"
            v-model="questionApplicant2DoB.Value"
            :rules="applicantDateOfBirthRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.GROSS_MONTHLY_INCOME"
            :helpText="LABEL_CONSTANTS.GROSS_MONTHLY_INCOME_HELP_TEXT"
            class="mt-3 mb-2"
          />
          <BaseInput
            ref="questionApplicant2GrossMonthlyIncome"
            :vid="questionApplicant2GrossMonthlyIncome.InterfaceKey"
            v-model="questionApplicant2GrossMonthlyIncome.Value"
            :value="questionApplicant2GrossMonthlyIncome.Value"
            prefix="£"
            moneyFormat
            dataUiid="questionApplicant2GrossMonthlyIncome"
            :hideDetails="false"
            :rules="applicant2GrossMonthlyRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '160px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />
        </div>

        <h2
          :class="questionSecondApplicantIncluded.Value ? 'mt-5' : 'mt-10'"
          class="font-24 font-lg-28 font-weight-bold primary--text"
        >
          Broker details
        </h2>

        <BaseLabel
          :text="LABEL_CONSTANTS.CREDIT_ARRANGED"
          :hintText="LABEL_CONSTANTS.CREDIT_ARRANGED_HINT_TEXT"
          class="mt-3 mb-2"
        />
        <BaseToggleButton
          v-model="questionCreditArranged.Value"
          :data-uiid="questionCreditArranged.InterfaceKey"
          :toggleButtonText="{
            yesDataUiid: `${questionCreditArranged.InterfaceKey}_Yes`,
            noDataUiid: `${questionCreditArranged.InterfaceKey}_No`,
          }"
          styleClass="mb-11"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
        />

        <div class="underwriting-questions-section">
          <h2 class="font-24 font-lg-28 font-weight-bold primary--text">
            Underwriting questions
          </h2>

          <BaseAlert
            color="var(--blue-100)"
            class="px-4 py-3 ma-0 my-6 border-sm border-solid border-info"
          >
            <div class="d-flex">
              <div class="mr-3">
                <v-icon color="var(--blue-500)">mdi-information</v-icon>
              </div>
              <div class="primary--text">
                <span class="font-weight-bold">Important!</span>&nbsp;The
                following questions must be answered for all applicants.
              </div>
            </div>
          </BaseAlert>

          <BaseLabel
            :text="LABEL_CONSTANTS.AWARE_OF_CLAIM_CARER"
            :helpText="LABEL_CONSTANTS.AWARE_OF_CLAIM_CARER_HELP_TEXT"
            class="mt-3 mb-2"
          />
          <BaseToggleButton
            v-model="questionApplicant1AwareOfClaimCarer.Value"
            :data-uiid="questionApplicant1AwareOfClaimCarer.InterfaceKey"
            :toggleButtonText="{
              yesDataUiid: `${questionApplicant1AwareOfClaimCarer.InterfaceKey}_Yes`,
              noDataUiid: `${questionApplicant1AwareOfClaimCarer.InterfaceKey}_No`,
            }"
            styleClass="mb-10"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.AWARE_JOB_AT_RISK"
            :helpText="LABEL_CONSTANTS.AWARE_JOB_AT_RISK_HELP_TEXT"
            class="mt-3 mb-2"
          />
          <BaseToggleButton
            v-model="questionApplicant1JobAtRisk.Value"
            :data-uiid="questionApplicant1JobAtRisk.InterfaceKey"
            :toggleButtonText="{
              yesDataUiid: `${questionApplicant1JobAtRisk.InterfaceKey}_Yes`,
              noDataUiid: `${questionApplicant1JobAtRisk.InterfaceKey}_No`,
            }"
            styleClass="mb-10"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.AWARE_FORMAL_NOTIFICATION_OF_CUTS"
            :helpText="
              LABEL_CONSTANTS.AWARE_FORMAL_NOTIFICATION_OF_CUTS_HELP_TEXT
            "
            class="mt-3 mb-2"
          />
          <BaseToggleButton
            v-model="questionApplicant1FormalNotificationOfCuts.Value"
            :data-uiid="questionApplicant1FormalNotificationOfCuts.InterfaceKey"
            :toggleButtonText="{
              yesDataUiid: `${questionApplicant1FormalNotificationOfCuts.InterfaceKey}_Yes`,
              noDataUiid: `${questionApplicant1FormalNotificationOfCuts.InterfaceKey}_No`,
            }"
            styleClass="mb-10"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          />

          <BaseLabel
            :text="LABEL_CONSTANTS.FORMAL_ADMINISTRATION_OR_LIQUIDATION"
            :helpText="
              LABEL_CONSTANTS.FORMAL_ADMINISTRATION_OR_LIQUIDATION_HELP_TEXT
            "
            class="mt-3 mb-2"
          />
          <BaseToggleButton
            v-model="questionApplicant1FormalAdministrationorLiquidation.Value"
            :data-uiid="
              questionApplicant1FormalAdministrationorLiquidation.InterfaceKey
            "
            :toggleButtonText="{
              yesDataUiid: `${questionApplicant1FormalAdministrationorLiquidation.InterfaceKey}_Yes`,
              noDataUiid: `${questionApplicant1FormalAdministrationorLiquidation.InterfaceKey}_No`,
            }"
            styleClass="mb-10"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            :min-width="$vuetify.breakpoint.lgAndUp ? '110' : ''"
          />
        </div>

        <BaseButton
          depressed
          rounded
          dense
          class="font-weight-bold font-20 pa-7 px-13 primary--text"
          type="submit"
          :color="'psorange'"
          :block="$vuetify.breakpoint.lgAndUp ? false : true"
          :text="
            $vuetify.breakpoint.lgAndUp
              ? 'CONTINUE TO COVER DETAILS'
              : 'CONTINUE'
          "
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  scrollTop,
  addFieldLabel,
  convertToBool,
  tryGoToNextStep,
} from "@/common/utils";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { ValidationObserver } from "vee-validate";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

import {
  ERROR_INVALID,
  ERROR_MSG_MAX_CHARACTER,
  ERROR_NAME_INVALID,
} from "@/constants/message.constants.js";
import {
  setItemDataUiids,
  APPLICANT_TITLE_ITEMS,
} from "@/constants/component.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import { DATE_REGEX, NAME_REGEX } from "@/constants/regex-patterns.constants";

import BaseLabel from "@/components/BaseComponents/BaseLabel";
import BaseInput from "@/components/BaseComponents/BaseInput";
import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseSelect from "@/components/BaseComponents/BaseSelect";
import BaseToggle from "@/components/BaseComponents/BaseToggle";
import BaseAlert from "@/components/BaseComponents/BaseAlert.vue";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton";
import numeral from "numeral";

export default {
  name: "YourDetailsPage",
  components: {
    ValidationObserver,
    BaseLabel,
    BaseToggleButton,
    BaseInput,
    BaseInputDate,
    BaseButton,
    BaseSelect,
    BaseToggle,
    BaseAlert,
  },
  data() {
    return {
      questionApplicant1DoB: {},
      questionApplicant1Forename: {},
      questionApplicant1Surname: {},
      questionApplicant1Title: {},
      questionApplicant1GrossMonthlyIncome: {},
      questionSecondApplicantIncluded: {},
      questionApplicant2DoB: {},
      questionApplicant2Forename: {},
      questionApplicant2Surname: {},
      questionApplicant2Title: {},
      questionApplicant2GrossMonthlyIncome: {},
      questionApplicant1AwareOfClaimCarer: {},
      questionApplicant1JobAtRisk: {},
      questionApplicant1FormalNotificationOfCuts: {},
      questionApplicant1FormalAdministrationorLiquidation: {},
      questionCreditArranged: {},
      NAME_REGEX,
      DATE_REGEX,
      LABEL_CONSTANTS,
      ERROR_NAME_INVALID,
      ERROR_MSG_MAX_CHARACTER,
      ERROR_INVALID,
      APPLICANT_TITLE_ITEMS,
      applicantDateOfBirthRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          date_valid: {
            errorMessageTemplate: ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          age_in_range: {
            min: 18,
            max: 64,
          },
        },
        LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL
      ),
      applicantFirstNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.FIRST_NAME_LABEL
      ),
      applicantLastNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 100,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.LAST_NAME_LABEL
      ),
      applicant1GrossMonthlyRules: {
        required: {
          required: true,
          fieldLabel: "Gross monthly income (£)",
        },
        regex: {
          required: true,
          pattern: "^[0-9,]+(.[0-9]{1,2})?$",
          customMessage:
            "Only numbers up to two decimal places are allowed in this field.",
        },
        max: {
          length: 10,
          fieldLabel: "Gross monthly income (£)",
          errorMessageTemplate: "{0} may not be greater than 8 characters.",
        },
      },
      applicant2GrossMonthlyRules: {
        required: {
          required: true,
          fieldLabel: "Gross monthly income (£)",
        },
        max_value: {
          max: 8000.0,
          customMessage:
            "Gross monthly income (£) must not be greater than £8,000.",
        },
        regex: {
          required: true,
          pattern: "^[0-9,]+(.[0-9]{1,2})?$",
          customMessage:
            "Only numbers up to two decimal places are allowed in this field.",
        },
        max: {
          length: 10,
          fieldLabel: "Gross monthly income (£)",
          errorMessageTemplate: "{0} may not be greater than 8 characters.",
        },
      },
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, [
      "quoteResponse",
      "questionMap",
      "restoringLastStep",
    ]),
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormDetails);

    if (!this.restoringLastStep) {
      return;
    }

    // work around running validate before the data has been added to input
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormDetails,
        async (form) => await form.validate(),
        ROUTE_NAME.MPPI.B2B.COVER_DETAILS
      );
    }, 0);
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "setIsExpiredFlag",
      "resetInvalidQuestions",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
      "refreshSessionAndNextStep",
    ]),

    applicantTitleOptions(uiid) {
      return setItemDataUiids(uiid, this.APPLICANT_TITLE_ITEMS);
    },

    onSetupAndLoadSavedData() {
      this.questionApplicant1DoB = this.questionMap["Applicant1DoB"];
      this.questionApplicant1Forename = this.questionMap["Applicant1Forename"];
      this.questionApplicant1Surname = this.questionMap["Applicant1Surname"];
      this.questionApplicant1Title = this.questionMap["Applicant1Title"];
      this.questionApplicant1GrossMonthlyIncome =
        this.questionMap["Applicant1GrossMonthlyIncome"];
      // work around error where user enter an integer 8 characters long, when retrieve the
      // data is returned as float an will have extra '.00' characters which will be triggered as an error
      if (this.questionApplicant1GrossMonthlyIncome?.Value) {
        this.questionApplicant1GrossMonthlyIncome.Value = numeral(
          this.questionApplicant1GrossMonthlyIncome.Value
        )
          .value()
          .toString();
      }

      this.questionSecondApplicantIncluded =
        this.questionMap["SecondApplicantIncluded"];

      this.questionApplicant2DoB = this.questionMap["Applicant2DoB"];
      this.questionApplicant2Forename = this.questionMap["Applicant2Forename"];
      this.questionApplicant2Surname = this.questionMap["Applicant2Surname"];
      this.questionApplicant2Title = this.questionMap["Applicant2Title"];
      this.questionApplicant2GrossMonthlyIncome =
        this.questionMap["Applicant2GrossMonthlyIncome"];
      // work around error where user enter an integer 8 characters long, when retrieve the
      // data is returned as float an will have extra '.00' characters which will be triggered as an error
      if (this.questionApplicant2GrossMonthlyIncome?.Value) {
        this.questionApplicant2GrossMonthlyIncome.Value = numeral(
          this.questionApplicant2GrossMonthlyIncome.Value
        )
          .value()
          .toString();
      }

      this.questionApplicant1AwareOfClaimCarer =
        this.questionMap["Applicant1AwareOfClaimCarer"];
      this.questionApplicant1JobAtRisk =
        this.questionMap["Applicant1JobAtRisk"];
      this.questionApplicant1FormalNotificationOfCuts =
        this.questionMap["Applicant1FormalNotificationOfCuts"];
      this.questionApplicant1FormalAdministrationorLiquidation =
        this.questionMap["Applicant1FormalAdministrationorLiquidation"];

      this.questionCreditArranged = this.questionMap["CreditArranged"];
      // cook data
      this.questionCreditArranged.Value = convertToBool(
        this.questionCreditArranged.Value
      );
      this.questionSecondApplicantIncluded.Value = convertToBool(
        this.questionSecondApplicantIncluded.Value
      );
      this.questionApplicant1AwareOfClaimCarer.Value = convertToBool(
        this.questionApplicant1AwareOfClaimCarer.Value
      );
      this.questionApplicant1JobAtRisk.Value = convertToBool(
        this.questionApplicant1JobAtRisk.Value
      );
      this.questionApplicant1FormalNotificationOfCuts.Value = convertToBool(
        this.questionApplicant1FormalNotificationOfCuts.Value
      );
      this.questionApplicant1FormalAdministrationorLiquidation.Value =
        convertToBool(
          this.questionApplicant1FormalAdministrationorLiquidation.Value
        );

      this.setupSubmitApplicant2Data();
    },

    async onSubmit() {
      const isValidForm = await this.$refs.observerFormDetails.validate();

      if (!isValidForm) {
        EventBus.$emit("validation-error", "Validation error occurred");
        return;
      }

      this.setupSubmitApplicant2Data();
      sessionStorage.removeItem("isNewQuoteFromExpiredQuote");

      this.saveProgress();
      this.refreshSessionAndNextStep(ROUTE_NAME.MPPI.B2B.COVER_DETAILS);
    },

    saveAndExit() {
      this.setupSubmitApplicant2Data();
      this.toggleGlobalSaveAndExitDialog();
    },

    setupSubmitApplicant2Data() {
      if (!this.questionSecondApplicantIncluded.Value) {
        this.questionApplicant2DoB.Value =
          this.questionApplicant2Forename.Value =
          this.questionApplicant2Surname.Value =
          this.questionApplicant2Title.Value =
          this.questionApplicant2GrossMonthlyIncome.Value =
          this.questionMap["Applicant2AwareOfClaimCarer"].Value =
          this.questionMap["Applicant2JobAtRisk"].Value =
          this.questionMap["Applicant2FormalNotificationOfCuts"].Value =
          this.questionMap[
            "Applicant2FormalAdministrationorLiquidation"
          ].Value =
          this.questionMap["Applicant2Aged18To64"].Value =
          this.questionMap["Applicant2LivingUK"].Value =
          this.questionMap["Applicant2SixteenHours"].Value =
          this.questionMap["Applicant2TemporaryWork"].Value =
          this.questionMap["Applicant2NamedOnMortgage"].Value =
          this.questionMap["Applicant2ResidentialMortgage"].Value =
          this.questionMap["Applicant2RepaymentsUpToDate"].Value =
          this.questionMap["Applicant2MedicalCondition"].Value =
          this.questionMap["Applicant1Benefit"].Value =
            null;
      } else {
        this.questionMap["Applicant2AwareOfClaimCarer"].Value =
          this.questionApplicant1AwareOfClaimCarer.Value;
        this.questionMap["Applicant2JobAtRisk"].Value =
          this.questionApplicant1JobAtRisk.Value;
        this.questionMap["Applicant2FormalNotificationOfCuts"].Value =
          this.questionApplicant1FormalNotificationOfCuts.Value;
        this.questionMap["Applicant2FormalAdministrationorLiquidation"].Value =
          this.questionApplicant1FormalAdministrationorLiquidation.Value;
      }
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.second-applicant-included-field {
  :deep(.v-icon) {
    margin-right: 16px !important;
  }

  :deep(.v-btn) {
    padding: 4px 4px !important;
  }
}
.sub-text {
  font-size: 14px !important;
  width: 60% !important;
  font-weight: 400;
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .underwriting-questions-section {
    max-width: 66%;
  }
}
</style>
